import React, { useContext, useEffect, useState } from "react";
import { putData } from "../../lib/utils";
import { useParams } from "react-router-dom";
import { Context } from "../contexts/AppContext";

const SettingsSideNav = () => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  const { galleryId } = useParams();

  const [toggles, setToggles] = useState([
    {
      label: "Downloads Button",
      description: "Allow visitors to download photos and videos.",
      isEnabled: false,
    },
    {
      label: "Share Button",
      description: "Enable Share Photo button with others.",
      isEnabled: false,
    },
    // {
    //   label: "TV Connect Button",
    //   description: "Allow casting media to TV devices.",
    //   isEnabled: false,
    // },
    // {
    //   label: "Play All Button",
    //   description: "Play all gallery media automatically.",
    //   isEnabled: false,
    // },
     {
      label: "Watermark Button",
      description: "Automatically add watermarks to gallery photos.",
      isEnabled: false,
    },
  ]);

  useEffect(() => {
    const setting = appState?.currentGalleryData?.setting;

    if (setting) {
      setToggles([
        {
          label: "Downloads Button",
          description: "Allow visitors to download photos and videos.",
          isEnabled: setting.download,
        },
        {
          label: "Share Button",
          description: "Enable Share Photo Buttons with others.",
          isEnabled: setting.share,
        },
        // {
        //   label: "TV Connect Button",
        //   description: "Allow casting media to TV devices.",
        //   isEnabled: setting.tv,
        // },
        // {
        //   label: "Play All Button",
        //   description: "Play all gallery media automatically.",
        //   isEnabled: setting.playall,
        // },
        {
          label: "Watermark Button",
          description: "Automatically add watermarks to gallery photos.",
          isEnabled: setting.watermark,
        },
      ]);
    }
  }, [appState?.currentGalleryData?.setting]);

  const handleToggle = async (index) => {
    const newToggles = [...toggles];
    newToggles[index].isEnabled = !newToggles[index].isEnabled;

    setToggles(newToggles);

    const obj = {
      download: newToggles[0].isEnabled,
      share: newToggles[1].isEnabled,
     // tv: newToggles[1].isEnabled,
      //playall: newToggles[2].isEnabled,
      watermark: newToggles[2].isEnabled,
    };

    const json = await putData(
      `galleries/gallery/settings/${galleryId}`,
      {
        setting: obj,
      }
    );

    if (json) {
      setAppState((prevState) => ({
        ...prevState,
        currentGalleryData: {
          ...prevState.currentGalleryData,
          setting: json.gallery.setting,
        },
      }));
    }
  };

  return (
    <div className="bg-gradient-to-b from-gray-900 to-black rounded-2xl border border-gray-800 shadow-2xl p-5">
      <div className="mb-5">
        <h2 className="text-lg font-semibold text-white">
          Gallery Settings
        </h2>
        <p className="text-gray-400 text-sm mt-1">
          Customize which controls are visible to your visitors.
        </p>
      </div>

      <div className="space-y-3">
        {toggles.map((toggle, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-4 rounded-xl bg-gray-900/60 border border-gray-800 hover:border-yellow-500/40 hover:bg-gray-800/50 transition-all duration-300"
          >
            <div className="pr-4">
              <h3 className="text-white font-medium text-sm">
                {toggle.label}
              </h3>
              <p className="text-gray-400 text-xs mt-1">
                {toggle.description}
              </p>
            </div>

            <label className="relative inline-flex cursor-pointer items-center">
              <input
                type="checkbox"
                checked={toggle.isEnabled}
                onChange={() => handleToggle(index)}
                className="sr-only peer"
              />

              <div
                className="
                  w-12 h-7
                  bg-gray-700
                  rounded-full
                  peer
                  peer-checked:bg-yellow-500
                  transition-colors
                  duration-300
                  after:content-['']
                  after:absolute
                  after:top-1
                  after:left-1
                  after:w-5
                  after:h-5
                  after:bg-white
                  after:rounded-full
                  after:transition-all
                  after:duration-300
                  peer-checked:after:translate-x-5
                  shadow-lg
                "
              />
            </label>


            
          </div>
        ))}
      </div>
    </div>
  );
};

export default SettingsSideNav;